function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(76,50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#ffffff",
  fillOpacity: 1,
  transform: "scale(1.13887 1.13887)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.875s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.875s"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(68.38477631085024,68.38477631085024)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(45)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#ffffff",
  fillOpacity: 0.875,
  transform: "scale(1.20137 1.20137)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.75s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.75s"
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(50,76)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#ffffff",
  fillOpacity: 0.75,
  transform: "scale(1.26387 1.26387)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.625s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.625s"
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(31.615223689149765,68.38477631085024)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(135)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#ffffff",
  fillOpacity: 0.625,
  transform: "scale(1.32637 1.32637)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.5s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.5s"
}))));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(24,50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#ffffff",
  fillOpacity: 0.5,
  transform: "scale(1.38887 1.38887)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.375s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.375s"
}))));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(31.61522368914976,31.615223689149765)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(225)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#ffffff",
  fillOpacity: 0.375,
  transform: "scale(1.45137 1.45137)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.25s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.25s"
}))));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(49.99999999999999,24)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(270)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#ffffff",
  fillOpacity: 0.25,
  transform: "scale(1.01387 1.01387)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.125s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "-0.125s"
}))));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(68.38477631085023,31.61522368914976)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(315)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#ffffff",
  fillOpacity: 0.125,
  transform: "scale(1.07637 1.07637)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "0s",
  values: "1.5 1.5;1 1",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  keyTimes: "0;1",
  dur: "1s",
  repeatCount: "indefinite",
  values: "1;0",
  begin: "0s"
}))));

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "30px",
    height: "30px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.24d21724.svg";
export { ForwardRef as ReactComponent };